<app-card class="px-5 py-4 w-100" style="margin-bottom: .8rem !important;"> 
  <div class="row mb-2">
    <div class="col-lg-9 my-auto">
      <span class="extrabold text-size-20px">{{ text }}</span>
    </div>
    <div class="col-lg-3 my-auto" *ngIf="!noSelect">
      <select class="form-select select-gray">
        <option>Esta semana</option>
      </select>
    </div>
  </div>
  <div *ngIf="type == '1'" style="position: relative; width: 99%; height: 45vh">
    <canvas
      baseChart
      [type]="'bar'"
      [data]="barChartData"
      [options]="barChartOptions"
      [legend]="lineChartLegend"
      [plugins]="lineChartPlugins"
    >
    </canvas>
  </div>
  <div *ngIf="type == '2'" style="position: relative; width: 99%; height: 30vh">
    <canvas
      baseChart
      [type]="'line'"
      [data]="lineChartData"
      [options]="lineChartOptions"
      [legend]="lineChartLegend"
      [plugins]="lineChartPlugins"
    >
    </canvas>
  </div>
</app-card>
